import Modal from "components/modal/Modal";
import { ReactComponent as CircleCheck } from "assets/images/circle-check.svg";
import { PendingItem } from "pages/dashboard/home/dashboardService";
import { Button } from "components/ui/button/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { TextWithNewlines } from "utilities/TextWithNewlines";
import "./document-uploader.scss";
import React from "react";

export interface DocumentUploaderProps {
  readonly pendingItems: PendingItem;
  readonly handleByAction?: () => void;
  readonly onClick?: () => void;
  readonly isUploadSuccess?: boolean;
  readonly hasInvalidDocuments?: boolean;
  readonly handlePreview?: (fileId: string, fileName: string) => void;
}
export default function DocumentUploader({
  pendingItems,
  handleByAction,
  onClick,
  isUploadSuccess,
  hasInvalidDocuments,
  handlePreview,
}: DocumentUploaderProps) {
  const renderModel = () => {
    if (isUploadSuccess) {
      return <DocumentSuccessModel pendingItems={pendingItems} onClick={onClick} />;
    }
    if (hasInvalidDocuments) {
      return <InvalidDocumentUpload pendingItems={pendingItems} handleByAction={handleByAction} handlePreview={handlePreview} />;
    }
    return <AdditionalDocumentUpload pendingItems={pendingItems} handleByAction={handleByAction} />;
  };

  return (
    <div className="document-uploader">
      <Modal
        defaultHeader
        defaultHandleHide={onClick}
        shouldShowCloseButton
        defaultHeaderName="Comments"
        defaultBody={false}
        customBody={renderModel()}
      />
    </div>
  );
}
const baseClass = "modal__body";
const AdditionalDocumentUpload = ({ pendingItems, handleByAction }: DocumentUploaderProps) => {
  return (
    <>
      <div className={`${baseClass}__title`}>{pendingItems.title}</div>
      <div className={`${baseClass}__icon ${baseClass}__icon--upload`} onClick={handleByAction} aria-hidden>
        <FontAwesomeIcon icon={solid("cloud-arrow-up")} />
        &nbsp;<span>Upload</span>
      </div>
      <div className={`${baseClass}__note`}>
        <TextWithNewlines text={pendingItems.note || ""} />
      </div>
    </>
  );
};
const InvalidDocumentUpload = ({ pendingItems, handleByAction, handlePreview }: DocumentUploaderProps) => {
  const formatString = (value: string) => {
    let formatted = value.replace(/([a-z])([A-Z])/g, "$1 $2");
    formatted = formatted.charAt(0).toUpperCase() + formatted.slice(1).toLowerCase();
    return formatted;
  };

  return (
    <>
      {pendingItems.documents?.map((item, index) => (
        <React.Fragment key={item.id}>
          <div className={`${baseClass}__title`}>{pendingItems.title}</div>
          <div className={`${baseClass}__document`}>
            <span>Document Item:</span>
            <span className={`${baseClass}__document-name`} onClick={() => handlePreview?.(item.id, item.docName)}>
              {item.docName}
            </span>
          </div>
          <div className={`${baseClass}__details`}>
            <span className={`${baseClass}__invalid-reason`}>Invalid: {formatString(item.invalidReason ?? "")}</span>
            <div className={`${baseClass}__icon ${baseClass}__icon--upload`} tabIndex={index} onClick={handleByAction}>
              <FontAwesomeIcon icon={solid("cloud-arrow-up")} />
              &nbsp;<span>Upload</span>
            </div>
          </div>
          <div className={`${baseClass}__note`}>
            <TextWithNewlines text={item.detailedExplanation || ""} />
          </div>
        </React.Fragment>
      ))}
    </>
  );
};
const DocumentSuccessModel = ({ pendingItems, onClick }: DocumentUploaderProps) => {
  return (
    <>
      <div className={`${baseClass}__title`}>{pendingItems.title}</div>
      <div className={`${baseClass}__icon ${baseClass}__icon--success`}>
        <CircleCheck className="validCheck margin-small" />
        &nbsp;<span>Uploaded</span>
      </div>
      <Button title="Return to dashboard" onClick={onClick} />
    </>
  );
};
